/* eslint-disable no-eval */
const scrollAnimate = require('./components/scrollAnimate');

module.exports = {
    getSliderLabels() {
        const $html = $('html');
        return {
            prev: $html.attr('data-slider-prev-label') || 'Previous slide',
            next: $html.attr('data-slider-next-label') || 'Next slide',
        };
    },

    getCloseLabel() {
        return $('html').attr('data-close-label') || 'Close';
    },

    /**
     * Get cookie value by cookie name from browser
     * @param {string} cookieName - name of the cookie
     * @returns {string} cookie value of the found cookie name
     */
    getCookie(cookieName) {
        const name = `${cookieName}=`;
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i += 1) {
            let cookieItem = cookieArray[i];
            while (cookieItem.charAt(0) === ' ') {
                cookieItem = cookieItem.substring(1);
            }
            if (cookieItem.indexOf(name) === 0) {
                return cookieItem.substring(name.length, cookieItem.length);
            }
        }
        return '';
    },

    swapImage(windowWidth, itemsArray, breakPoint, isSource) {
        Array.from(itemsArray).forEach((element) => {
            const currentItem = $(element);
            const imageDesktop = currentItem.data('src-desktop');
            const imageMobile = currentItem.data('src-mobile');
            const imageUrl = windowWidth < breakPoint + 1 ? imageMobile : imageDesktop;
            if (isSource) {
                currentItem.attr('src', imageUrl);
            } else {
                currentItem.css('background-image', imageUrl);
            }
        });
    },
    appendToUrl(url, params) {
        let newUrl = url;
        newUrl
            += (newUrl.indexOf('?') !== -1 ? '&' : '?')
            + Object.keys(params)
                .map(key => `${key}=${encodeURIComponent(params[key])}`)
                .join('&');

        return newUrl;
    },
    clone(methodToClone) {
        return `(${JSON.parse(JSON.stringify(methodToClone.toString()))})`;
    },
    setCookie(cookieName) {
        let d = new Date();

        d = new Date(d.getTime() + 1000 * 86400);
        document.cookie = `${cookieName}=true;expires=${d};path=/`;
    },
    displayPaymentErrors(errorText) {
        const componentErrors = $('.paymentErrors');
        if (componentErrors.length) {
            const componenentErrorMsg = componentErrors.find('.modal-body .error-message');
            componentErrors.find('.modal-body .error-message-text').html(errorText);
            $('.paymentErrors').fadeIn();
            componenentErrorMsg.show();
            $('.continue-payment').on('click', () => {
                $('.paymentErrors').fadeOut();
            });
        } else {
            if ($('#dwfrm_billing:visible').length > 0) {
                var htmlError = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
                    <button type="button" class="close no-btn" data-dismiss="alert" aria-label="${this.getCloseLabel()}">
                    <span aria-hidden="true" class="icon-cross-line"></span>
                    </button>
                    ${errorText}</div>`;
                if ($('#dwfrm_billing .error-message').length > 0) {
                    $('#dwfrm_billing .error-message').html(htmlError);
                } else {
                    htmlError = `<div class="error-message">${htmlError}</div>`;
                    $('#dwfrm_billing').prepend(htmlError);
                }
                $('#dwfrm_billing .error-message').show();
                scrollAnimate($('#dwfrm_billing'), ($('header').length > 0 ? $('header').height() + 20 : 30));
            } else {
                $('.error-message').show();
                $('.error-message-text').html(errorText);
                scrollAnimate($('.error-message'));
            }
        }
    },
    checkIlegalCharacters(value, type) {
        let valid = true;
        valid = type.toString() === 'text' || type.toString() === 'select' || type.toString() === 'textarea' ? !value.match(/[&\\#+()$~%'":*?<>{}]/) : true;
        return valid;
    },

    redirectCheckoutToPaymentMethod(searchParams) {
        if (searchParams) {
            searchParams.set('stage', 'payment');
            window.history.replaceState({}, '', `${window.location.pathname}?${searchParams}`);
            window.location.reload();
        }
    },


    dateDiff(d1, d2) {
        // SECONDS
        const secDiff = Math.floor((d2 - d1) / 1000);

        // MINUTES
        const minutesDiff = Math.floor(secDiff / 60);

        // HOURS
        const hoursDiff = Math.floor(minutesDiff / 60);

        // DAYS
        const daysDiff = Math.floor(hoursDiff / 24);

        return {
            minutesDiff: minutesDiff - (60 * hoursDiff),
            hoursDiff: hoursDiff - (24 * daysDiff),
            daysDiff,
        };
    },

    updateMiniCartSize(timeout) {
        setTimeout(() => {
            const miniCartDiscounts = $('.approaching-discounts');
            let miniCartDiscountsHeight = 0;
            if (miniCartDiscounts.length) {
                miniCartDiscountsHeight = miniCartDiscounts.innerHeight();
            }
            const miniCartHeaderHeight = $('.minicart-container .header').innerHeight() + 1;
            let miniCartFooterHeight = 0;
            if ($('.minicart-container .minicart-footer').length) {
                miniCartFooterHeight = $('.minicart-container .minicart-footer').innerHeight() + 1;
            }
            let miniCartErrorHeight = 0;
            if ($('.minicart-container .minicart-error').length) {
                miniCartErrorHeight = $('.minicart-container .minicart-error').innerHeight();
            }
            const summaryHeightRemove = miniCartHeaderHeight
                                    + miniCartFooterHeight
                                    + miniCartDiscountsHeight
                                    + miniCartErrorHeight;

            $('.minicart-container .product-summary').css('height', window.innerHeight - summaryHeightRemove);
            $('.minicart-container .container.cart').addClass('show');
        }, timeout);
    },

    displayFuturePromotionsInfo(thisTarget) {
        // FUTURE PROMOTIONS
        if (thisTarget.find('.promotion-message').length !== 0) {
            thisTarget.find('.promotion-message').html('');
        }
        const futurePromotionDate = thisTarget.attr('data-futurepromotiondate');
        const futurePromotionPrice = thisTarget.attr('data-futurepromotionprice');
        const futurePromotionTextColor = thisTarget.attr('data-futurepromotiontextcolor') !== '' ? `color:${thisTarget.attr('data-futurepromotiontextcolor')};` : '';
        const futurePromotionBackgroundColor = thisTarget.attr('data-futurepromotionbackgroundcolor') !== '' ? `background-color:${thisTarget.attr('data-futurepromotionbackgroundcolor')};` : '';
        if (futurePromotionDate && futurePromotionPrice) {
            const dateNow = new Date();
            const dateFuture = new Date(futurePromotionDate);
            const distance = this.dateDiff(dateNow, dateFuture);
            if (distance && (distance.minutesDiff || distance.hoursDiff || distance.daysDiff)) {
                const data = {
                    minutesDiff: distance.minutesDiff,
                    hoursDiff: distance.hoursDiff,
                    daysDiff: distance.daysDiff,
                    promoPrice: futurePromotionPrice,
                };

                $.ajax({
                    url: thisTarget.attr('data-urlmessage'),
                    type: 'get',
                    data,
                    success: (response) => {
                        thisTarget.find('.price').addClass('promo-price-wrapper');
                        const thisTargetPromos = thisTarget.find('.future-promotions');
                        const tilePromoContent = `<span class="promo-price" style="${futurePromotionTextColor}">${response.price}</span>${response.message}<span class="promo-date" style="${futurePromotionTextColor}">${response.date}</span>`;
                        if (thisTargetPromos.length) {
                            thisTarget.find('.future-promotions').html(tilePromoContent);
                        } else {
                            thisTarget.find('.price').append(`<div class="future-promotions" style="${futurePromotionTextColor} ${futurePromotionBackgroundColor}">${tilePromoContent}</div>`);
                        }
                    },

                });
            }
        }
    },
};
